import { FC } from 'react'
import * as brandAtoms from 'src/atoms/brands'
import { AMLocation } from 'src/common-services'
import { LogoAvatar } from 'src/components/logo-avatars'
import { LightTooltip } from 'src/components/tooltip/light-tooltip'
import { SHOPPING_CENTER_NAICS_CODE } from 'src/constants/mapbox'
import { ShoppingCenterIcon } from 'src/components/insights/icons/shopping-center'
import { useCachedRecoilValue } from 'src/utils/recoil'
import { Colors } from 'src/components/theme'
import styled from '@emotion/styled'

const ShoppingCenterLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.primaryBlue500};
  border-radius: 4px;
  flex-shrink: 0;
`

type BaseLocation = {
  naicsCode: AMLocation['naicsCode']
  brandId?: AMLocation['brandId']
  name: AMLocation['name']
}

type Props = {
  location: BaseLocation
  size?: number
}

const LocationLogoInner: FC<Props> = ({ location, size = 32 }) => {
  const logoUrl = useCachedRecoilValue(brandAtoms.brandLogoUrl(location.brandId), null)
  return <LogoAvatar size={size} alt={location.name} url={logoUrl} />
}

export function LocationLogo(props: Props) {
  const { location, size = 32 } = props

  if (location.naicsCode === SHOPPING_CENTER_NAICS_CODE) {
    return (
      <ShoppingCenterLogo style={{ width: size, height: size }}>
        <ShoppingCenterIcon size={size / 1.8} color="white" />
      </ShoppingCenterLogo>
    )
  }

  return <LocationLogoInner {...props} />
}

type BrandLogoProps = {
  brandId: string
  size?: number
  noBorder?: boolean
  tooltip?: string
  outlineColor?: string
}

export const BrandLogo: FC<BrandLogoProps> = ({ brandId, size = 32, noBorder = false, tooltip, outlineColor }) => {
  const logoUrl = useCachedRecoilValue(brandAtoms.brandLogoUrl(brandId), null)
  return (
    <LightTooltip title={tooltip || ''} placement="top" arrow={false}>
      <LogoAvatar size={size} alt={logoUrl || brandId} url={logoUrl} outlineColor={outlineColor} />
    </LightTooltip>
  )
}
